import React from "react"
import SelectMenu from "@kit/design/select-menu"
import { useListProducts } from "sdk/commerce/products/queries"

export const ProductMenu = ({ editor, node }) => {
  const { data } = useListProducts()

  const options =
    data?.map(product => ({ value: product.id, label: product.name })) || []

  const handleChange = event => {
    const { value } = event.target

    const product = data.find(product => product.id === value)

    const { id, domain, url } = product

    editor.command("setNodeByKey", node.key, {
      data: { ...node.data.toJS(), id, domain, url }
    })
  }

  return (
    <div className="p-4 w-64">
      <SelectMenu
        className="w-full"
        name="productId"
        options={options}
        onChange={handleChange}
        value={node.data.get("id")}
      />
    </div>
  )
}
